<form [formGroup]="form">
  <mat-form-field
    appearance="fill"
    color="accent"
  >
    <mat-icon matPrefix>search</mat-icon>
    <mat-label>{{ label }}</mat-label>
    <input
      type="text"
      matInput
      [formControlName]="controlName"
      [matAutocomplete]="auto"
      [required]="required"
    />
    <mat-autocomplete
      class="card"
      #auto="matAutocomplete"
      [displayWith]="locationName"
    >
      <mat-option
        *ngFor="let location of (locations$ | async)"
        [value]="location"
      >
        {{ location.label }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
